import { createValidationSchema, PosixDate, stringField, uuidField, } from "@for-it/domain-lib";
import { TenantEntity } from "../../entities/tenant.js";
import { PaymentCredentialsInvalidError } from "../../errors/payment-credentials-invalid-error.js";
import { TenantNotFoundError } from "../../errors/tenant-not-found-error.js";
export const updateTenantPaymentCredentials = {
    name: "updateTenantPaymentCredentials",
    description: "Updates or creates payment credentials for a tenant with encrypted secrets.",
    type: "command",
    isAuthRequired: true,
    payloadSchema: createValidationSchema({
        tenantId: uuidField({
            required: true,
            message: "Debe ingresar un ID de tenant válido",
        }),
        provider: stringField({
            required: true,
            message: "El provider es requerido",
        }),
        accessToken: stringField({
            required: true,
            message: "El access token es requerido",
        }),
        webhookSecret: stringField({
            required: true,
            message: "El webhook secret es requerido",
        }),
        publicKey: stringField({
            required: false,
            message: "La public key es opcional",
        }),
        transferDetails: (value) => {
            if (value === undefined || value === null) {
                return { isValid: true, value: undefined };
            }
            if (typeof value !== "object" || Array.isArray(value)) {
                return {
                    isValid: false,
                    error: "transferDetails debe ser un objeto",
                };
            }
            return {
                isValid: true,
                value: value,
            };
        },
    }),
    useCase: async ({ db, tenantConnectionResolver, secretVault, }, { tenantId, provider, accessToken, webhookSecret, publicKey, transferDetails, }) => {
        const tenant = await db.findOne(TenantEntity, {
            where: { id: tenantId },
        });
        if (!tenant)
            return new TenantNotFoundError();
        if (!accessToken || accessToken.trim() === "") {
            return new PaymentCredentialsInvalidError();
        }
        if (!webhookSecret || webhookSecret.trim() === "") {
            return new PaymentCredentialsInvalidError();
        }
        const connection = await tenantConnectionResolver.open(tenant.dbName);
        try {
            return await connection.manager.transaction(async (manager) => {
                await manager.query(`UPDATE payment_credentials SET isActive = false WHERE provider = ? AND isActive = true`, [provider]);
                const encryptedAccessToken = secretVault.encrypt(accessToken);
                const encryptedWebhookSecret = secretVault.encrypt(webhookSecret);
                const now = new PosixDate();
                await manager.query(`INSERT INTO payment_credentials (id, createdAt, updatedAt, provider, encryptedAccessToken, encryptedWebhookSecret, publicKey, transferDetails, isActive)
                     VALUES (?, ?, ?, ?, ?, ?, ?, ?, true)`, [
                    globalThis.crypto.randomUUID(),
                    now.timestamp,
                    now.timestamp,
                    provider,
                    JSON.stringify(encryptedAccessToken),
                    JSON.stringify(encryptedWebhookSecret),
                    publicKey ?? null,
                    transferDetails
                        ? JSON.stringify(transferDetails)
                        : null,
                ]);
                return {
                    provider,
                    isConfigured: true,
                    publicKey: publicKey ?? null,
                    transferDetails: transferDetails ?? null,
                };
            });
        }
        finally {
            await connection.release();
        }
    },
};
